// extracted by mini-css-extract-plugin
module.exports = {"navBack":"NavBack_navBack__1B6Z9","customLink":"NavBack_customLink__2zsYH","arrow":"NavBack_arrow__2jJpR","left":"NavBack_left__1RKRm","customMargin":"NavBack_customMargin__2dnad"};